import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const trendingUp = svgToTinyDataUri(
  `<svg width="34" height="20" viewBox="0 0 34 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_5530_14971" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="-4" y="-10" width="41" height="40">
<rect x="-3.33398" y="-10" width="40" height="40" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_5530_14971)">
<path d="M2.33333 20L0 17.6667L12.3333 5.25L19 11.9167L27.6667 3.33333H23.3333V0H33.3333V10H30V5.66667L19 16.6667L12.3333 10L2.33333 20Z" fill="#AFE321"/>
</g>
</svg>`
);
